import axios from 'axios';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Breadcrumb from '../../Layout/Breadcrumb';
import { Spinner, Tabs, Tab } from 'react-bootstrap';
import { Card, CardBody, Table, CardHeader } from 'reactstrap';
import { FaUsers, FaTrash } from "react-icons/fa";
import { Link } from 'react-router-dom';
import ModalComponent from  '../../ModalComponent';
import Select from 'react-select';
import PaginateComponent from "../../PaginateComponent";

class DetailGroupUserComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            groupUser: {},
            error: false,
            messageError: '',
            loadPage: true,
            isModal: false,
            contentModal: '',
            isBtnConfirm: true,
            isSpinner: false,
            btnConfirmDisabled: false,
            keyAction: 0,
            action: '',
            listUser: [],
            listGroupProduct: [],
            userAdd: [],
            groupProductAdd: [],
            choosseUser: [],
            choosseGroupProduct: [],
            alert: {
                error: false,
                message: ''
            },
            loadUser: true,
            loadGroupProduct: true,
            totalPageUser: 0,
            perPageUser: 0,
            currenPageUser: 0,
            groupUserId: 0,
            totalPageGroupProduct: 0,
            perPageGroupProduct: 0,
            currenPageGroupProduct: 0,
        }
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({
            groupUserId: this.props.groupUserId
        })
        await this.detailGroupUser(this.props.groupUserId);
        await this.getListUserByGroupUser(this.props.groupUserId);
        await this.getListGroupProductByGroupUser(this.props.groupUserId);
    }

    detailGroupUser = (groupUserId) => {
        // this.setState({
        //     loadPage: true
        // });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/user/detailGroupUser/' + groupUserId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    let userAdd = [];
                    let groupProductAdd = [];
                    ref.data.content.user_add.forEach( user => {
                        userAdd.push({ value: user.id, label: user.name + " - " + user.email })
                    })
                    ref.data.content.group_product_add.forEach( group_product => {
                        groupProductAdd.push({ value: group_product.id, label: group_product.name })
                    })
                    this.setState({
                        groupUser: ref.data.content,
                        loadPage: false,
                        userAdd: userAdd,
                        groupProductAdd: groupProductAdd,
                    })
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadPage: false,
                    isLoading: false
                })
            })
    }

    getListUserByGroupUser = (groupUserId) => {
        this.setState({
            loadUser: true,
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/user/getListUserByGroupUser/' + groupUserId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data.error);
                if (ref.data.error === 0) {
                    this.setState({
                        listUser: ref.data.listUser.data,
                        loadUser: false,
                        totalPageUser: ref.data.listUser.total,
                        perPageUser: ref.data.listUser.per_page,
                        currenPageUser: ref.data.listUser.current_page
                    })
                    // console.log(this.state.listUser);
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadUser: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadUser: false,
                })
            })
    }

    paginateListUser = () => {
        if (this.state.totalPageUser > this.state.perPageUser) {
            return (
                <PaginateComponent
                    total={this.state.totalPageUser}
                    perPage={this.state.perPageUser}
                    currentPage={this.state.currenPageUser}
                    btnPaginate={ (page) => this.btnPaginateListUser(page) }
                />
            );
        }
    }

    btnPaginateListUser = (page) => {
        this.setState({
            loadUser: true,
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/user/getListUserByGroupUser/' + this.props.groupUserId + "?page=" + page,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data.error);
                if (ref.data.error === 0) {
                    this.setState({
                        listUser: ref.data.listUser.data,
                        loadUser: false,
                        totalPageUser: ref.data.listUser.total,
                        perPageUser: ref.data.listUser.per_page,
                        currenPageUser: ref.data.listUser.current_page
                    })
                    // console.log(this.state.listUser);
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadUser: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadUser: false,
                })
            })
    }

    listUser = () => {
        if ( this.state.listUser.length ) {
            return (
                <Card>
                    <CardHeader>
                        <button type="button" className="btn btn-info" onClick={ () => this.showModal(0, 'addUser') }>Thêm khách hàng</button>
                    </CardHeader>
                    <CardBody  className="table-responsive">
                        <Table className="table table-sm table-bordered table-hover rounded table-list">
                            <thead className="primary">
                                <tr>
                                    <th>Tên khách hàng</th>
                                    <th>Email</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.listUser.map( (user, key) => {
                                        return (
                                            <tr key={key}>
                                                <td><Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + user.id}>{ user.name }</Link></td>
                                                <td><Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + user.id}>{ user.email }</Link></td>
                                                <td>
                                                    {
                                                        this.state.groupUser.id !== 0 ? (
                                                            <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.showModal( key, 'user' ) }>
                                                                <FaTrash />
                                                            </button>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                            <tfoot className="mt-3">
                                <tr>
                                    <td colSpan={15}>
                                        { this.paginateListUser() }
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                    </CardBody>
                </Card>
            );
        } else {
            return (
                <Card>
                    <CardHeader>
                        <button type="button" className="btn btn-info" onClick={ () => this.showModal(0, 'addUser') }>Thêm khách hàng</button>
                    </CardHeader>
                    <CardBody>
                        <div className="text-danger text-center">
                            Không có dữ liệu khách hàng trong đại lý này
                        </div>
                    </CardBody>
                </Card>
            )
        }
    }

    getListGroupProductByGroupUser = (groupUserId) => {
        this.setState({
            loadGroupProduct: true,
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/user/getListGroupProductByGroupUser/' + groupUserId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data.error);
                if (ref.data.error === 0) {
                    this.setState({
                        listGroupProduct: ref.data.listUser.data,
                        loadGroupProduct: false,
                        totalPageGroupProduct: ref.data.listUser.total,
                        perPageGroupProduct: ref.data.listUser.per_page,
                        currenPageGroupProduct: ref.data.listUser.current_page
                    })
                    // console.log(this.state.listUser);
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadGroupProduct: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadGroupProduct: false,
                })
            })
    }

    paginateListGroupProduct = () => {
        if (this.state.totalPageGroupProduct > this.state.perPageGroupProduct) {
            return (
                <PaginateComponent
                    total={this.state.totalPageGroupProduct}
                    perPage={this.state.perPageGroupProduct}
                    currentPage={this.state.currenPageGroupProduct}
                    btnPaginate={ (page) => this.btnPaginateListGroupProduct(page) }
                />
            );
        }
    }

    btnPaginateListGroupProduct = (page) => {
        this.setState({
            loadGroupProduct: true,
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/user/getListGroupProductByGroupUser/' + this.props.groupUserId + "?page=" + page,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data.error);
                if (ref.data.error === 0) {
                    this.setState({
                        listGroupProduct: ref.data.listUser.data,
                        loadGroupProduct: false,
                        totalPageGroupProduct: ref.data.listUser.total,
                        perPageGroupProduct: ref.data.listUser.per_page,
                        currenPageGroupProduct: ref.data.listUser.current_page
                    })
                    // console.log(this.state.listUser);
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadGroupProduct: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadGroupProduct: false,
                })
            })
    }

    listGroupProduct = () => {
        if ( this.state.listGroupProduct.length ) {
            return (
                <Card>
                    <CardHeader>
                        <button type="button" className="btn btn-success" onClick={ () => this.showModal(0, 'addGroupProduct') }>Thêm nhóm sản phẩm</button>
                    </CardHeader>
                    <CardBody  className="table-responsive">
                        <Table className="table table-sm table-bordered table-hover rounded  table-list">
                            <thead className="primary">
                                <tr>
                                    <th width="70%">Tên nhóm sản phẩm</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.listGroupProduct.map( (group_product, key) => {
                                    return (
                                        <tr key={key}>
                                            <td><Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + group_product.id}>{ group_product.name }</Link></td>
                                            <td>
                                                {
                                                    this.state.groupUser.id !== 0 ? (
                                                        <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.showModal( key, 'group_product' ) }>
                                                            <FaTrash />
                                                        </button>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                            <tfoot className="mt-3">
                                <tr>
                                    <td colSpan={15}>
                                        { this.paginateListGroupProduct() }
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                    </CardBody>
                </Card>
            );
        } else {
            return (
                <Card>
                    <CardHeader>
                        <button type="button" className="btn btn-success" onClick={ () => this.showModal(0, 'addGroupProduct') }>Thêm nhóm sản phẩm</button>
                    </CardHeader>
                    <CardBody>
                        <div className="text-danger text-center">
                            Không có dữ liệu nhóm sản phẩm trong đại lý này
                        </div>
                    </CardBody>
                </Card>
            )
        }
    }

    showModal = (key, type) => {
        let titleModal;
        let modalBody;
        if ( type === 'user' ) {
            titleModal = 'Xóa khách hàng khỏi đại lý';
            modalBody = this.modalBody(key, type);
        }
        else if ( type === 'group_product' ) {
            titleModal = 'Xóa nhóm sản phẩm khỏi đại lý';
            modalBody = this.modalBody(key, type);
        }
        else if ( type === 'addUser' ) {
            titleModal = 'Thêm khách hàng vào đại lý';
            modalBody = this.modalBody(key, type);
        }
        else if ( type === 'addGroupProduct' ) {
            titleModal = 'Thêm nhóm sản phẩm vào đại lý';
            modalBody = this.modalBody(key, type);
        }
        this.setState({
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            action: key,
            typeAction: type,
        })
    }

    modalBody = (key, type) => {
        if ( type === 'user' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa khách hàng <b className="text-danger">{ this.state.groupUser.users[key].name }</b> ra khỏi đại lý này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này xóa khách hàng này khỏi đại lý và tất cả dịch vụ của khách hàng này sẽ chuyển từ dịch vụ
                        của đại lý này thành dịch vụ của đại lý cơ bản. Vui lòng kiểm tra lại trước khi xác nhận.
                    </span>
                </div>
            )
        }
        else if ( type === 'group_product' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa nhóm sản phẩm <b className="text-danger">{ this.state.groupUser.group_products[key].name }</b> ra khỏi đại lý này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động xóa nhóm sản phẩm này khỏi đại lý đại lý này và trở thành nhóm sản phẩm cơ bản. Vui lòng kiểm tra lại trước khi xác nhận.
                    </span>
                </div>
            )
        }
        else if ( type === 'addUser' ) {
            return (
                <>
                    <div className="form-group">
                        <label htmlFor="name">Chọn khách hàng</label>
                        <Select
                            options={this.state.userAdd}
                            onChange={this.changeUserAdd}
                            isMulti
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder={'Chọn nhiều khách hàng'}
                        />
                    </div>
                </>
            )
        }
        else if ( type === 'addGroupProduct' ) {
            return (
                <>
                    <div className="form-group">
                        <label>Chọn khách hàng</label>
                        <Select
                            options={this.state.groupProductAdd}
                            onChange={this.changeGroupProductAdd}
                            isMulti
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder={'Chọn nhiều khách hàng'}
                        />
                    </div>
                </>
            )
        }
    }

    changeUserAdd = selectedOption => {
        let choosseUser = [];
        selectedOption.forEach( select => {
            choosseUser.push( select.value );
        })
        this.setState({
            choosseUser: choosseUser
        })
    }

    changeGroupProductAdd = selectedOption => {
        let choosseGroupProduct = [];
        selectedOption.forEach( select => {
            choosseGroupProduct.push( select.value );
        })
        this.setState({
            choosseGroupProduct: choosseGroupProduct
        })
    }

    hiddenModal = () => {
        this.setState({
            keyAction: 0,
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        if ( this.validate() ) {
            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
            })
            let form = {};
            if ( this.state.typeAction === 'user' ) {
                form = {
                    action: 'deleteUser',
                    actionId: this.state.groupUser.users[ this.state.keyAction ].id,
                    groupUserId: this.state.groupUser.id,
                };
            }
            else if ( this.state.typeAction === 'group_product' ) {
                form = {
                    action: 'deleteGroupProduct',
                    actionId: this.state.groupUser.group_products[ this.state.keyAction ].id,
                    groupUserId: this.state.groupUser.id,
                };
            }
            else if ( this.state.typeAction === 'addUser' ) {
                form = {
                    action: 'addUser',
                    actionId: this.state.choosseUser,
                    groupUserId: this.state.groupUser.id,
                };
            }
            else if ( this.state.typeAction === 'addGroupProduct' ) {
                form = {
                    action: 'addGroupProduct',
                    actionId: this.state.choosseGroupProduct,
                    groupUserId: this.state.groupUser.id,
                };
            }
            else {
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        modalBody: this.modalBodyConfirm(1,'Hành động không phù hợp'),
                        title: this.state.contentModal.title
                    }
                });
                return false;
            }
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.put( process.env.REACT_APP_API_URL + '/api/admin/user/actionGroupUser', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        isSpinner: false,
                    });
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        if ( this.state.typeAction === 'user' ) {
                            if ( !ref.data.error ) {
                                this.state.groupUser.users.splice( this.state.keyAction , 1);
                            }
                        }
                        else if ( this.state.typeAction === 'group_product' ) {
                            if ( !ref.data.error ) {
                                this.state.groupUser.group_products.splice( this.state.keyAction , 1);
                            }
                        }
                        else if ( this.state.typeAction === 'addUser' ) {
                            this.state.choosseUser.forEach( userId => {
                                this.state.userAdd.forEach( (userAdd, index) => {
                                    if ( userAdd.id === userId ) {
                                        this.state.userAdd.splice( index , 1);
                                    }
                                })
                            })
                            this.detailGroupUser(this.props.groupUserId);
                        }
                        else if ( this.state.typeAction === 'addGroupProduct' ) {
                            this.state.choosseGroupProduct.forEach( groupProductId => {
                                this.state.groupProductAdd.forEach( (groupProductAdd, index) => {
                                    if ( groupProductAdd.id === groupProductId ) {
                                        this.state.groupProductAdd.splice( index , 1);
                                    }
                                })
                            })
                            this.detailGroupUser(this.props.groupUserId);
                        }
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    validate = () => {
        return true;
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chi tiết đại lý " + this.state.groupUser.name} page={"Đại lý"} icon={<FaUsers className="breadcrumb-icon"/>}/>
                            <Tabs defaultActiveKey="user" id="uncontrolled-tab-example" className="mb-3 tab-menu">
                                <Tab eventKey="user" title="Khách hàng">
                                    {
                                        this.state.loadUser ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="danger" />
                                            </div>
                                        ) : (
                                            this.listUser()
                                        )
                                    }
                                </Tab>
                                <Tab eventKey="groupUser" title="Nhóm sản phẩm" className="mb-3 tab-menu">
                                    {
                                        this.state.loadGroupProduct ? (
                                            <div className="cr-page-spinner load-page">
                                                <Spinner animation="border" variant="danger" />
                                            </div>
                                        ) : (
                                            this.listGroupProduct()
                                        )
                                    }
                                </Tab>
                            </Tabs>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({type : 'logOut'}))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailGroupUserComponent);